export default __webpack_public_path__ + "static/icon-33-1-c053ee210bb1e3e70d9a459c0343f8c5.png";